enum SigningStage {
	default,
	signing,
	complete,
}

export default SigningStage
